import { useAppSelector, useIframe, useMyApp, useSession, useTranslate } from '@common/hooks'
import { getAppSlug } from '@common/utils/uuid'
import { useMemo } from 'react'
import Skeleton from 'react-loading-skeleton'

import classNames from './styles.module.scss'
import Bars from './widgets/Bars'
import MyReview from './widgets/MyReview'
import OwnerSharedLink from './widgets/OwnerSharedLink'
import RatingForm from './widgets/RatingForm'
import Reviews from './widgets/Reviews'
import Score from './widgets/Score'


export default function ApplicationRating(): JSX.Element {
  const { interpolate, translate } = useTranslate()

  const app = useAppSelector(store => store.application.data) as IApplication
  const { isLoading, data: appRating } = useAppSelector(store => store.applicationRating)
  const { isAuthorizedUser } = useSession()
  const { isAppAuthor } = useMyApp(app)

  const slug = getAppSlug(app.id, app.name) as string

  const iframeParams = useMemo(() => ({
    title: interpolate(translate('%s reviews'), [app.name]),
    url: `/apps/${slug || ''}/reviews`,
  }), [app, slug])

  useIframe(iframeParams)

  return (
    <div className={classNames.wrapper}>
      {isLoading && !appRating && (
        <>
          <div className={classNames.scoreRow}>
            <Skeleton className={classNames.skeletonScore} duration={0.5}/>
            <Skeleton className={classNames.skeletonBars} duration={0.5}/>
          </div>
          <Skeleton className={classNames.skeletonReviews} duration={0.5}/>
          <Skeleton className={classNames.skeletonReviews} duration={0.5}/>
          <Skeleton className={classNames.skeletonReviews} duration={0.5}/>
        </>
      )}
      <>
        {appRating?.app.ratingAvg
          ? (
            <div className={classNames.scoreRow}>
              <Score/>
              <Bars/>
              {!isAppAuthor && <MyReview />}
            </div>
            )
          : isAppAuthor && !isLoading && appRating
            ? <OwnerSharedLink />
            : null
        }
        {appRating && !appRating?.rating && !isAppAuthor && isAuthorizedUser ? <RatingForm/> : null}
        <Reviews />
      </>
    </div>
  )
}
